import { render } from "./ShortForm.vue?vue&type=template&id=7c249f47&scoped=true"
import script from "./ShortForm.vue?vue&type=script&lang=js"
export * from "./ShortForm.vue?vue&type=script&lang=js"

import "./ShortForm.vue?vue&type=style&index=0&id=7c249f47&scoped=true&lang=scss"

import exportComponent from "/Users/macmeow/Documents/vue/feedback_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c249f47"]])

export default __exports__